// @flow
import * as React from 'react';
import { Route } from 'react-router';
import ListPage from 'esm-web-pro/containers/pages/ListPage';
import {
    FormattedMessage, IntlShape, injectIntl, defineMessages,
} from 'react-intl';
import { Trash } from 'grommet-icons';
import ActionsColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/Action/ActionsColumn';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import DateTimeColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/DateTimeColumn';
import JSONCell from 'esm-web-pro/components/tables/JSONCell';
import EditIcon from 'esm-web-pro/components/icons/EditIcon';

type Props = {
    intl: IntlShape,
}

const messages = defineMessages({
    auditEvent: {
        id: 'adminpage-audit-event-plural',
        defaultMessage: 'Audits',
    },
    auditEventType: {
        id: 'adminpage-audit-event-type-plural',
        defaultMessage: 'Audits',
    },
});

const AuditRoutes = (auditProps: Props) => {
    const { intl: { formatMessage, locale } } = auditProps;

    return (
        <>
            <Route
                path="/administration/audits/events"
                render={(props) => (
                    <ListPage
                        {...props}
                        resourceName="auditEvent"
                        filterExcludeFields={['event_date', 'type__code', 'is_conversation']}
                        permissions={['audit.view_auditevent', 'audit.delete_auditevent',
                            'audit.change_auditevent', 'audit.add_auditevent']}
                        title={formatMessage(messages.auditEvent)}
                        columns={[
                            {
                                Header: <FormattedMessage
                                    id="audit-module"
                                    defaultMessage="Module"
                                />,
                                accessor: 'object_type.app_name',
                                minWidth: 20,
                            },
                            {
                                Header: (
                                    <FormattedMessage
                                        id="audit-objecttype"
                                        defaultMessage="Object Type"
                                    />
                                ),
                                accessor: 'object_type.name',
                                minWidth: 15,
                            },
                            {
                                Header: <FormattedMessage
                                    id="audit-typename"
                                    defaultMessage="Type name"
                                />,
                                accessor: `type.translations.${locale}.name`,
                                minWidth: 30,
                            },
                            {
                                Header: <FormattedMessage
                                    id="audit-eventdate"
                                    defaultMessage="Event date"
                                />,
                                accessor: 'event_date',
                                minWidth: 30,
                                Cell: DateTimeColumn,
                            },
                            {
                                Header: <FormattedMessage
                                    id="audit-createdby"
                                    defaultMessage="User"
                                />,
                                accessor: 'created_by',
                                minWidth: 30,
                            },
                            {
                                Header: (
                                    <FormattedMessage
                                        id="audit-data"
                                        defaultMessage="Data"
                                    />
                                ),
                                accessor: 'data',
                                minWidth: 30,
                                Cell: JSONCell,
                            },
                        ]}
                    />
                )}
            />
            <Route
                path="/administration/audits/eventtypes"
                render={(props) => (
                    <ListPage
                        {...props}
                        resourceName="auditEventType"
                        permissions={['audit.view_auditeventtype', 'audit.delete_auditeventtype',
                            'audit.change_auditeventtype', 'audit.add_auditeventtype']}
                        title={formatMessage(messages.auditEventType)}

                        columns={[
                            {
                                Header: (
                                    <FormattedMessage
                                        id="auditeventtype-name"
                                        defaultMessage="Name"
                                    />
                                ),
                                accessor: `translations.${locale}.name`,
                                minWidth: 30,
                            },
                            {
                                Header: (
                                    <FormattedMessage
                                        id="auditeventtype-data"
                                        defaultMessage="Data"
                                    />
                                ),
                                accessor: 'data',
                                minWidth: 30,
                                Cell: JSONCell,
                            },
                            {
                                actions: [{
                                    label: formatMessage(actionMessages.edit),
                                    resourceName: 'attributeType',
                                    to: '/administration/audits/eventtypes/update/{uuid}',
                                    type: 'link',
                                    icon: <EditIcon />,
                                },
                                {
                                    label: formatMessage(actionMessages.delete),
                                    resourceName: 'auditEventType',
                                    accessor: 'uuid',
                                    type: 'delete',
                                    icon: <Trash />,
                                    nameAccessor: `translations.${locale}.name`,
                                },
                                ],
                                Cell: ActionsColumn,
                                minWidth: 40,
                            },
                        ]}
                        newObjectUrl="/administration/audits/eventtypes/new"
                        newObjectLabel={(
                            <FormattedMessage
                                id="adminpage-audit-event-type-new"
                                defaultMessage="New audit event type"
                            />
                        )}
                        editObjectLabel={(
                            <FormattedMessage
                                id="adminpage-audit-event-type-edit"
                                defaultMessage="Edit audit event type"
                            />
                        )}
                    />
                )}
            />
        </>
    );
};

export default injectIntl(AuditRoutes);
